const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const moment = require("moment");

const TrainerCore = require("../../../shared/TrainerCore");
const URLMake = require("../../../shared/URLMake");
const withSetURL = require("../../core/hoc/withSetURL");
const GradeChapter = require("../../../shared/GradeChapter");
const Link = require("../../core/view/Link");
const ProfileUtil = require("../../core/util/ProfileUtil");
const ActivityStats = require("../../core/view/ActivityStats");
const MiniCalendar = require("./MiniCalendar");
const HistoryIcon = require("../../office/HistoryIcon");
const OpsLab = require("../../lab/vault/OpsLab");
const StudentName = require("./StudentName");
const StatsIcon = require("../../core/view/StatsIcon");
const StudentRegistration = require("../registration/StudentRegistration");
const OfficeSummaryStats = require("../../report/OfficeSummaryStats");
const Mixpanel = require("../../core/util/Mixpanel");

const styles = require("./styles/StudentStats.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withSetURL(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "StudentStats",

		propTypes: {
			studentID: PT.number.isRequired,
			studentData: PT.object.isRequired,
			recentData: PT.object.isRequired,
			twoWeekStats: PT.object,
			openResult: PT.func,

			// Injected by HOCs
			setURL: PT.func.isRequired,
		},

		//Used by views that scroll to Expandables
		getRef: function() {
			return this.mainContainer;
		},

		renderRecentLessons: function(recentLessons) {
			return _.map(recentLessons, (lesson, i) => {
				const {
					chapterID,
					finishStatus,
					percentComplete,
					stars,
					blockID,
					typeID,
					displayName,
					celestialID,
					resultID,
					isTrophy,
					requirementLevel,
				} = lesson;
				const chapterContext = GradeChapter.chapterIDToContext(chapterID);
				const isBonus = TrainerCore.isBonusBlock(requirementLevel);
				const icon = isTrophy ? (
					<StatsIcon
						className={styles.lessonTrophy}
						type="trophy"
						style="office"
						disabled={finishStatus !== "completed"}
						onClick={() =>
							this.props.openResult({
								resultID: parseInt(resultID),
								blockID,
								userID: this.props.studentID,
								isTrophy,
							})
						}
					/>
				) : (
					<HistoryIcon
						type={typeID ? OpsLab.getCelestialHashFromID(celestialID) : null}
						backgroundIconType={isBonus ? "bonus" : null}
						finishStatus={finishStatus}
						numStars={stars}
						celestialEarned={finishStatus === "completed"}
						hideStarIcon={true}
						percentComplete={percentComplete}
						grayBackground={true}
						onClick={() =>
							this.props.openResult({
								resultID: parseInt(resultID),
								blockID,
								userID: this.props.studentID,
								isTrophy,
							})
						}
					/>
				);
				let name;
				if (isTrophy || chapterID) {
					name = `${chapterContext.gradeNumber}.${chapterContext.chapterIndex +
						1}: ${displayName}`;
				} else if (typeID) {
					const typeName = OpsLab.getTypeNameFromID(typeID);
					name = `${typeName}: ${displayName}`;
				}
				return (
					<div className={styles.recentLesson} key={"lesson" + i}>
						<div className={styles.lessonName}>{name}</div>
						<div className={styles.lessonIcon}>{icon}</div>
					</div>
				);
			});
		},

		renderMainReportContent: function() {
			const {studentData, studentID, recentData, twoWeekStats} = this.props;
			const recentLessons = this.renderRecentLessons(studentData.recentLessons);
			const recentStatsContent = (
				<div className={styles.activityStats}>
					<ActivityStats stats={twoWeekStats} style="parent" />
				</div>
			);

			let recentLessonsContent;
			if (recentLessons.length) {
				recentLessonsContent = (
					<div className={styles.recentLessons}>{recentLessons}</div>
				);
			} else {
				recentLessonsContent = (
					<div className={styles.noLessons}>{"No recent lessons."}</div>
				);
			}

			const today = moment().format("MMM Do");
			const twoWeeksAgo = moment()
				.subtract(13, "day")
				.format("MMM Do");

			const calendarContainer = (
				<div className={styles.calendarContainer}>
					<div className={styles.subheader}>
						<b>Recent Activity:</b>
						{twoWeeksAgo + " - " + today}
					</div>
					<MiniCalendar studentID={studentID} recentActivity={recentData} />
				</div>
			);

			const activityContainer = (
				<div className={styles.activityContainer}>{recentStatsContent}</div>
			);

			const lessonsContainer = (
				<div className={styles.lessonsContainer}>
					<div className={styles.subheader}>
						<b>Recent Lessons</b>
					</div>
					{recentLessonsContent}
				</div>
			);

			return (
				<div className={styles.panelMainContent}>
					<div className={styles.leftContainer}>
						{calendarContainer}
						{activityContainer}
					</div>
					<div className={styles.rightContainer}>{lessonsContainer}</div>
				</div>
			);
		},

		render: function() {
			const {studentData, studentID} = this.props;
			const {
				hasCompletedRegistration,
				hasAcademyPurchase,
				activity,
				everHadBAOSubscription,
			} = studentData;

			let mainContent, header;

			const fullReportLink = URLMake.forParentStudent(studentID, {
				grade: studentData.grade,
				type: "progress",
			});

			// If hasCompletedRegistration is true, we still want to show the registration page
			// if the student hasn't played or the parent hasn't finished secondary registration
			const shouldShowRegistrationEvenThoughCompleted =
				(studentData.registrationStep &&
					studentData.registrationStep !== "final") ||
				!activity.lastPlayed;
			if (
				(hasCompletedRegistration &&
					!shouldShowRegistrationEvenThoughCompleted) || // BA subs who have completed registration and played
				(hasAcademyPurchase && !everHadBAOSubscription) // Academy Users who haven't subscribed to BA at all (if they sub we want the first one to apply)
			) {
				const totalTime = ProfileUtil.getDurationVeryShortString(
					ProfileUtil.getMinutesForTimeData(activity.totalTimeData)
				);
				mainContent = this.renderMainReportContent();
				header = (
					<div className={styles.studentHeader}>
						<Link className={styles.nameStats} to={fullReportLink}>
							<StudentName studentData={studentData} />
							<div className={styles.stats}>
								<OfficeSummaryStats
									className={styles.statsInner}
									xp={studentData.xp}
									stars={studentData.stars}
									trophies={studentData.trophies}
									problemsCorrect={studentData.problemsCorrect}
									time={totalTime}
								/>
							</div>
						</Link>
						<div className={styles.buttonOuter}>
							<Link to={fullReportLink} className={styles.button}>
								Full Report
							</Link>
							<Link to={URLMake.forAccount()} className={styles.button}>
								Manage Account
							</Link>
						</div>
					</div>
				);
			} else {
				//Show registration info either if registration isn't complete or
				//if the student hasn't started playing yet.
				mainContent = <StudentRegistration {...this.props} />;
				let guideLink = (
					<Link
						to={URLMake.forParentSupport("getstarted")}
						isNewTab={true}
						className={styles.regGuideLink}
					>
						{"Need help?"}
						<span
							className={styles.supportPageLinkLong}
							onClick={() => {
								Mixpanel.track("Student Registration: Help Site Link Click", {
									linkText: "Check out our Help Site.",
									destination: "Parent Support Play Page",
									source: "Student Stats",
								});
							}}
						>
							{" Check out our Help Site."}
						</span>
					</Link>
				);
				//Hide the link if on the first or last step as they have their own links
				if (_.includes(["welcome", "final"], studentData.registrationStep)) {
					guideLink = null;
				}
				if (studentData.registrationStep === "final") {
					//Make the top section a link if the registration is complete
					header = (
						<Link className={styles.studentHeader} to={fullReportLink}>
							<StudentName studentData={studentData} forReg={true} />
							{guideLink}
						</Link>
					);
				} else {
					header = (
						<div className={styles.panelRowReg}>
							<StudentName studentData={studentData} forReg={true} />
							{guideLink}
						</div>
					);
				}
			}

			return (
				<div
					className={styles.studentPanel}
					key={"student" + studentID}
					id={"student" + studentID}
					ref={a => (this.mainContainer = a)}
				>
					{header}
					{mainContent}
				</div>
			);
		},
	})
);
